import {escapeHtmlSymbols} from "./atUtils"

class MessageResource
{
    constructor(messageBundle, messageSubstitutions)
    {
        this.messageBundle = messageBundle;
        this.messageSubstitutions = messageSubstitutions;
    }

    applyMacrosSubstitutions(message, escapeMacros)
    {
        // quick check
        if (message.indexOf("#") < 0)
            return message;

        for (let i = 0; i < this.messageSubstitutions.length; i++)
        {
            message = message.replace(
                    this.messageSubstitutions[i].regexp,
                    escapeMacros ? escapeHtmlSymbols(this.messageSubstitutions[i].value) : this.messageSubstitutions[i].value
            );
        }

        return message;
    }

    applyParamsSubstitutions(message, params, escape = false)
    {
        if (params && params.length > 0)
        {
            for (let j = 0; j < params.length; j++)
                message = message.replace(new RegExp("{" + j + "[,a-zA-Z]*}", "g"), escape ? escapeHtmlSymbols(params[j]) : params[j]);
        }

        return message;
    }

    applyAllSubstitutions(message, params, escapeMacros, escapeArgs)
    {
        message = this.applyMacrosSubstitutions(message, escapeMacros);
        message = this.applyParamsSubstitutions(message, params, escapeArgs);
        return message;
    }

    getMessage(key, params, escapeMacros, escapeArgs)
    {
        let message = this.messageBundle[key];
        if (typeof message === typeof undefined)
        {
            if (typeof console !== typeof undefined && console.trace)
                console.trace("could not find message with key: " + key);
            return undefined;
        }
        return this.applyAllSubstitutions(message, params, escapeMacros, escapeArgs);
    }

    getEscapedMessage(key, params)
    {
        return escapeHtmlSymbols(this.getMessage(key, params));
    }

    getMessageWithEscapedMacros(key, params)
    {
        return this.getMessage(key, params, true);
    }

    getMessageWithEscapedArgs(key, params)
    {
        return this.getMessage(key, params, false, true);
    }

    getEscapedMessageNoEscapeArgs(key, params)
    {
        //noinspection JSUnresolvedVariable
        let message = this.messageBundle[key];
        if (typeof message === typeof undefined)
        {
            if (typeof console !== typeof undefined && console.trace)
                console.trace("could not find message with key: " + key);
            return undefined;
        }
        message = this.applyMacrosSubstitutions(message);
        message = escapeHtmlSymbols(message);
        message = this.applyParamsSubstitutions(message, params);
        return message;
    }

    printMessage(key, params, escapeMacros)
    {
        document.write(this.getMessage(key, params, escapeMacros));
    }
}

const messageResource = new MessageResource(window.MESSAGE_BUNDLE, window.MESSAGE_SUBSTITUTIONS);
export default messageResource;



// WEBPACK FOOTER //
// ./web/js/messageResource.js